<template>
  <div class="fb-go-thanks-wrapper">
    <div class="fb-go-thanks-badge"></div>
    <div class="fb-go-thanks">
      <h1>Congratulations!</h1>
      <p>{{ youCompletedActivityLabel }}</p>
      <div class="badges">
        <div class="badge-text">{{ activitiesCompletedSubmConfirmLabel }}</div>
        <div class="badge-count">{{ completedItems }}</div>
      </div>
      <div class="fb-actions">
        <md-button @click="goBack" class="md-raised md-primary fb-next">View submission</md-button>
      </div>
      <div class="fb-actions">
        <md-button @click="goTo('/learner')" class="md-secondary fb-prev">Back to Home</md-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "GoThanks",
  props: ["routeName", "nid"],
  data() {
    return {
      page: [],
      id: 0,
      completedItems: "",
      youCompletedActivityLabel:
        window.drupalSettings.group_catch_config.labels.you_completed_activity,
      activitiesCompletedSubmConfirmLabel:
        window.drupalSettings.group_catch_config.labels
          .activities_completed_subm_confirm,
    };
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    },
    goBack() {
      this.goTo("/strategy/" + this.id + "/go");
      //this.$emit("back-to-go");
    },
    continueGo() {
      this.goTo("/strategy/" + this.id + "/go");
      //this.$emit("set-tab", "go");
    },
  },
  created() {
    this.page = window.location.pathname.split("/")[1];
    this.id = window.location.pathname.split("/")[2];
  },
  mounted() {
    fetch("/api/progress", { credentials: "include" })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.hasOwnProperty(this.$status.ACTIVITY_COMPLETED)) {
          this.completedItems = Object.values(
            data[this.$status.ACTIVITY_COMPLETED]
          ).length;
        }
      });
  },
};
</script>
<style lang="scss" scoped>
.fb-go-thanks-wrapper {
  text-align: center;
  position: relative;
  margin-top: 115px;
  @media all and (max-width: $breakpoint-medium) {
    margin-top: 50px;
  }
}
.fb-go-thanks-badge {
  background-image: url("../assets/badge_big.svg");
  width: 200px;
  height: 200px;
  display: inline-block;
  position: absolute;
  top: -100px;
  left: 50%;
  margin-left: -100px;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 50%;
  background-color: $white;
  @media all and (max-width: $breakpoint-medium) {
    width: 100px;
    height: 100px;
    top: -40px;
    background-size: 60px;
    margin-left: -50px;
  }
}
.fb-go-thanks {
  @media all and (max-width: $breakpoint-medium) {
    padding-top: 16px;
  }
  .fb-actions {
    max-width: 583px;
    width: 100%;
    margin: 8px auto;
    .fb-prev {
      color: $blue-dark;
      @media all and (min-width: $breakpoint-medium) {
        font-size: 18px;
        height: 40px;
      }
    }
    .fb-next.md-raised.md-primary {
      background: $blue-dark;
      color: $white;
      @media all and (min-width: $breakpoint-medium) {
        font-size: 20px;
        height: 40px;
      }
    }
    @media all and (max-width: $breakpoint-medium) {
      margin: 0px 10px;
    }
  }
  padding-top: 60px;
  padding-bottom: 16px;
  flex-direction: column;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #3c3c3c;
  font-family: $font-source-sans-pro;
  p {
    color: #3c3c3c;
    font-family: $font-source-sans-pro;
  }
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  h1 {
    color: rgb(60, 60, 60);
    font-family: $font-filson-soft;
    font-size: 36px;
    line-height: 54px;
    @media all and (max-width: $breakpoint-medium) {
      font-size: 32px;
    }
  }
  a:not(.md-button) {
    font-family: $font-source-sans-pro;
    color: rgb(60, 60, 60);
    text-decoration: underline;
    font-weight: 300;
    &:hover {
      color: rgb(60, 60, 60);
    }
  }
  border-radius: 20px;
  margin: 0px;
  width: auto;
  background-color: $white;
  background-position: center center;
  background-repeat: no-repeat;
  .badges {
    @media all and (max-width: $breakpoint-medium) {
      margin: 16px 10px;
    }
    display: inline-block;
    background: $grey-light;
    max-width: 341px;
    margin: 30px 10px;
    padding: 16px 80px;
    border-radius: 10px;
    background-image: url("../assets/superhero.svg");
    background-repeat: no-repeat;
    background-position: left 20px center;
    .badge-text {
      color: rgb(60, 60, 60);
      font-family: $font-source-sans-pro;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }
    .badge-count {
      &::before {
        content: "";
        display: inline-block;
        width: 32px;
        height: 32px;
        background-image: url("../assets/badge.svg");
        background-repeat: no-repeat;
        background-position: center top 4px;
      }
      color: rgb(60, 60, 60);
      font-family: $font-filson-soft;
      font-size: 36px;
      line-height: 54px;
    }
  }
}
</style>
